

export const AlertQueryKeys = {
    all: ['alert'] as const,
    lists: () => [...AlertQueryKeys.all, 'list'] as const,
    list: (id: number) => [...AlertQueryKeys.lists(), id] as const,
    details: () => [...AlertQueryKeys.all, 'detail'] as const,
    detail: (id: number) => [...AlertQueryKeys.details(), id] as const,
}

export const AlertExecutionQueryKeys = {
    all: ['alert-execution'] as const,
    lists: () => [...AlertExecutionQueryKeys.all, 'list'] as const,
    details: () => [...AlertExecutionQueryKeys.all, 'detail'] as const,
    detail: (id: number) => [...AlertExecutionQueryKeys.details(), id] as const,
    notifications: (id: number) => [...AlertExecutionQueryKeys.details(), "notifications", id] as const,
}